import Phone from "src/assets/svg/phone.svg";

import styles from "./styles.module.css";

const EstateOfficeAvailability = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.dot}></div>
      Ofisin Durumu:
      <span className={styles.available}>&nbsp;Müsait</span>
      <Phone />
    </div>
  );
};

export default EstateOfficeAvailability;
